import { Routes, Route, BrowserRouter } from 'react-router-dom';

import Layout from './Layout';
import Home from './pages/Home';
import Machine from './pages/Machine';
import Program from './pages/Program';
import Form from './pages/Form';

import '../assets/styles/styles.scss';

function App() {
  return (
    <Layout>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/:slug" element={<Machine />} />
          <Route path="mnfg-186">
            <Route index element={<div className="error-404">There's nothing here: 404!</div>} />
            <Route path=":slug" element={<Program />} />
          </Route>
          <Route path="form" element={<Form />} />
        </Routes>
      </BrowserRouter>
    </Layout>
  );
}

export default App;
